import { useTranslation } from 'next-i18next'
import React from 'react'

import Button from '../button'

type ExportCardModalProps = {
  isOpen: boolean
  onClose: () => void
  onShare: () => void
}

export function ExportCardModal({
  isOpen,
  onClose,
  onShare,
}: ExportCardModalProps) {
  const { t } = useTranslation('avaliacao360')

  if (!isOpen) return null

  return (
    <div
      className="cardModal fixed inset-0 bg-black/95 flex flex-col justify-start items-center z-[1000] overflow-y-auto"
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 z-10 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        onClick={onClose}
        aria-label="Fechar"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      <div
        className="cardModalContent w-full max-w-lg mx-auto text-center px-4 py-8 sm:py-12"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          id="exportedCard"
          className="mx-auto w-full h-auto bg-transparent flex justify-center items-center mb-4 sm:mb-6"
          style={{ minHeight: '200px' }}
        ></div>

        <p className="text-white text-base sm:text-lg my-4 sm:my-6 px-4">
          {t('cards.copyImage')}
        </p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 px-4">
          <Button
            label={t('cards.copyImageShort')}
            color="red"
            action={onShare}
            className="w-full sm:w-auto"
          />
          <Button
            label={t('cards.close')}
            color="white"
            action={onClose}
            className="w-full sm:w-auto"
          />
        </div>
      </div>
    </div>
  )
}
